// extracted by mini-css-extract-plugin
module.exports = {"tab":"_RxCroT4","info":"jgFqEl8S"};